var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"scrollbar",class:_vm.classes},[_c('div',{ref:"simpleBar",staticClass:"simple-bar",style:({ 'max-height': _vm.maxHeight ? `${_vm.maxHeight}px` : 'none' })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }